import { RouteComponentProps } from 'react-router';

import * as Api from './Api';
import * as Data from './Data';
import type { State } from './Store';
import * as Store from './Store';

// Injected by the router.
export interface Routes {
  params: {
    concessionStoreId?: string;
    dlid?: string;
    id?: string;
    lat?: string;
    lng?: string;
    location?: string;
    orderId?: string;
    phone?: string;
    placeId?: string;
    prid?: string;
    type?: 'collection' | 'delivery';
    vrid?: string;
  };
}

export type RouteParams = RouteComponentProps<Routes, Routes['params']>;

export type RouteRestaurant = Data.Async<
  Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail
>;

export const FindRestaurant = (
  state: State,
  route: Routes,
): RouteRestaurant => {
  let r:
    | Data.Async<Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail>
    | undefined;

  switch (route.params.type) {
    case 'collection':
      r = state.collectionRestaurants[route.params.id];
      break;
    case 'delivery': {
      const key = Store.DeliveryKey(
        Number(route.params.vrid),
        Number(route.params.id),
      );
      r = state.deliveryRestaurants[key];
      break;
    }
    default: {
      // try get any w same vrId
      if (route.params.vrid) {
        r = Object.values(state.collectionRestaurants).find(
          // eslint-disable-next-line eqeqeq
          (cr) =>
            cr.status === 'success' &&
            cr.data.VirtualRestaurantId === Number(route.params.vrid),
        );

        if (!r) {
          r = Object.values(state.deliveryRestaurants).find(
            // eslint-disable-next-line eqeqeq
            (dr) =>
              dr.status === 'success' &&
              dr.data.VirtualRestaurantId === Number(route.params.vrid),
          );
        }
      }
      break;
    }
  }

  if (!r) {
    r = { status: 'none' };
  }

  return r;
};

export const OutsideDeliveryZone = (restaurant: RouteRestaurant) => {
  switch (restaurant.status) {
    case 'pending':
    case 'none':
      return false;
    default:
      return (
        restaurant.data.DeliveryType === Api.DeliveryType.Delivery &&
        restaurant.data.UserOutsideDeliveryZone
      );
  }
};
